import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { ulVariants } from "./Ul.variants.js";
const Ul_Ul = /*#__PURE__*/ forwardRef(function({ className, children, ...props }, ref) {
    const classes = cn(ulVariants(props), className);
    const domProps = cleanProps(props, Object.keys(ulVariants.variants));
    return /*#__PURE__*/ jsx("ul", {
        ref: ref,
        className: classes,
        ...domProps,
        children: children
    });
});
export { Ul_Ul as Ul };
